import React from 'react'
import { Platform } from 'react-native'

import { MY_TEAMS_ADVISOR } from '@zet/constants'
import { H5, H6, Stack, XStack } from '@zet/design-system'
import { APP_NAME } from '@zet/end-points'
import { i18n } from '@zet/localization'

import Star from '../../assets/svg/star.svg'
import { OngoingSales } from '../../components/ongoingSales'
import TierBenefitAlert from '../../components/tierBenefitAlert'
import { CustomerLead } from '../../hooks/useBrandRecommandations'

type OfferAndLoyaltyCoinsProps = {
  customerId: number
  totalOffers: number
  currentTierName?: string
  categoryId: string
  categoryName?: string
  customerPhoneNumber?: string
  customerLeads?: Array<CustomerLead>
  headerText?: string
  prequalifiedOffers?: boolean
  routeName: string
}

const isWeb = Platform.OS === 'web'

const OfferAndLoyaltyCoins = ({
  customerId,
  categoryName,
  totalOffers,
  currentTierName,
  categoryId,
  customerLeads,
  customerPhoneNumber,
  headerText,
  prequalifiedOffers,
  routeName,
}: OfferAndLoyaltyCoinsProps) => {
  if (!isWeb) {
    return (
      <>
        {/* Lead Section */}
        {!!customerId && Boolean(customerLeads?.length) && (
          <>
            <OngoingSales
              customerId={customerId}
              count={customerLeads?.length}
              brandIds={customerLeads?.map((lead) => lead?.partnerId)}
              customerPhoneNumber={customerPhoneNumber}
            />
            <Stack className="bg-grays-20 h-2" />
          </>
        )}

        {prequalifiedOffers && (
          <XStack className=" py-4/2 z-50 mb-2 items-center bg-white px-3">
            <Star width={20} height={20} />
            <H5 className="ml-2 font-bold text-black">
              {i18n.t('brandListing.offerHeader.title', { count: totalOffers })}
            </H5>
          </XStack>
        )}
        {/* Count of offer returned when route from category flow */}
        {categoryId && totalOffers > 0 && !prequalifiedOffers && (
          <Stack
            className={`border-grays-30 py-4/2 z-50 mb-3  border-b bg-white px-3 ${
              !(!!customerId && Boolean(customerLeads?.length)) &&
              routeName !== 'category'
                ? 'mt-3 border-t'
                : ''
            }`}
          >
            <H6 className="text-grays-80">
              {headerText
                ? headerText
                : i18n.t(
                    customerId
                      ? 'rejectionPayout.availableRecoOffer'
                      : 'rejectionPayout.availableCategoryOffer',
                    {
                      count: totalOffers,
                      categoryName: categoryName?.endsWith?.('s')
                        ? categoryName?.slice?.(0, -1)
                        : categoryName,
                    }
                  )}
            </H6>
            {APP_NAME !== MY_TEAMS_ADVISOR && !!currentTierName && (
              <TierBenefitAlert
                tier={currentTierName}
                categoryId={categoryId}
              />
            )}
          </Stack>
        )}
      </>
    )
  }
}

export default OfferAndLoyaltyCoins
